import { useState } from "react";
import { Bell, BellRing, Share2 } from "lucide-react";
import { toast } from "sonner";
import { api, errMsg } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { ShareCardDialog, useShareCard } from "@/components/ShareCard";

export const TopicActions = ({ liveId, topic, following, setFollowing, i }) => {
  const s = useShareCard();
  const [busy, setBusy] = useState(false);
  const on = following.includes(topic.trim().toLowerCase().replace(/\s+/g, " "));
  const toggle = async () => {
    setBusy(true);
    try {
      const { data } = await api.post(`/live/${liveId}/topics/follow`, { topic, follow: !on });
      setFollowing(data.following);
      toast.success(on ? `You won't get alerts about ${topic}` : `We'll tell you when Middle's perspective on ${topic} changes`);
    } catch (e) { toast.error(errMsg(e)); }
    setBusy(false);
  };
  return (
    <div className="flex flex-wrap gap-2">
      <Button size="sm" variant={on ? "default" : "outline"} className="rounded-full" disabled={busy} onClick={toggle} data-testid={`topic-follow-${i}`}>
        {on ? <BellRing size={14} className="mr-1.5" /> : <Bell size={14} className="mr-1.5" />}{on ? "Following this topic" : "Alert me when this changes"}</Button>
      <Button size="sm" variant="outline" className="rounded-full" disabled={s.busy} onClick={() => s.make({ kind: "topic", live_id: liveId, topic })} data-testid={`topic-share-${i}`}><Share2 size={14} className="mr-1.5" />Share as a card</Button>
      <ShareCardDialog card={s.card} title={`${topic}: Middle's perspective`} onClose={s.close} />
    </div>
  );
};
